<template>
  <div class="bg-white rounded shadow-sm border border-gray-200 ">
      <slot></slot>
  </div>
</template>

<script>
export default {
  name: "BaseCard"
}
</script>